import React, { Fragment } from "react"
import classnames from "classnames"
import styles from "./styles.css"

const CustomerGreetingsSkeleton = () => {
  const titleClasses = classnames(styles.skeletonText, styles.skeleton)

  return (
    <Fragment>
      <div className={titleClasses}></div>
    </Fragment>
  )
}

export default CustomerGreetingsSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/CustomerGreetings/index.js